var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.25C13.2 7.94036 12.6403 8.5 11.95 8.5C11.2596 8.5 10.7 7.94036 10.7 7.25C10.7 6.55964 11.2596 6 11.95 6C12.6403 6 13.2 6.55964 13.2 7.25Z",
    fill: "#E30031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69995 11C9.69995 10.4477 10.1477 10 10.7 10H12.2C12.7522 10 13.2 10.4477 13.2 11V16H13.7C14.2522 16 14.7 16.4477 14.7 17C14.7 17.5523 14.2522 18 13.7 18H10.7C10.1477 18 9.69995 17.5523 9.69995 17C9.69995 16.4477 10.1477 16 10.7 16H11.2V12H10.7C10.1477 12 9.69995 11.5523 9.69995 11Z",
    fill: "#E30031"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z",
    fill: "#E30031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.0f9e080732daf06c13b087b14bf03d48.svg";
export { ForwardRef as ReactComponent };